import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

interface TaxCertificateData {
    name: string;
    type: string;
    base64: string;
}

type HandlerType = ApiHandlerDiscreteParameter<{ taxID: string; taxCertificate: TaxCertificateData | null }, {}>;

export const SetTaxId: HandlerType = props => {
    if (props.parameter.taxID !== undefined) {
        props.dispatch({
            type: "Custom/TaxFields/UpdateTaxID",
            taxID: props.parameter.taxID,
        } as any);
    }
};

export const SetTaxCertificate: HandlerType = props => {
    if (props.parameter.taxCertificate !== undefined) {
        props.dispatch({
            type: "Custom/TaxFields/UpdateTaxCertificate",
            taxCertificate: props.parameter.taxCertificate,
        } as any);
    }
};

export const chain = [SetTaxId, SetTaxCertificate];
const setTaxFields = createHandlerChainRunner(chain, "SetTaxFields");
export default setTaxFields;
